import { render, staticRenderFns } from "./imperfekt-av-svaga-verb.vue?vue&type=template&id=57f66bc2&scoped=true"
import script from "./imperfekt-av-svaga-verb.vue?vue&type=script&lang=js"
export * from "./imperfekt-av-svaga-verb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f66bc2",
  null
  
)

export default component.exports